import * as React from 'react';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { useEffect, useState } from 'react';
import {
  StripeCardElementChangeEvent,
  StripeCardElementOptions,
} from '@stripe/stripe-js';
import { Button, Container, Paper, Stack, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setStripeCardTokenId } from '../../store/setupUserSlice';
import Log from '../../lib/log';

// ログの初期化
const log = new Log('SetupPayment');

// カード入力オプション（郵便番号は不要）
const CARD_OPTIONS: StripeCardElementOptions | undefined = {
  iconStyle: 'solid',
  hidePostalCode: true,
  style: {
    base: {
      iconColor: '#2196f3',
      color: '#000',
      fontWeight: 500,
      fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
      fontSize: '16px',
      fontSmoothing: 'antialiased',
      ':-webkit-autofill': {
        color: '#2196f3',
      },
      '::placeholder': {
        color: '#2196f3',
      },
    },
    invalid: {
      iconColor: '#f50057',
      color: '#f50057',
    },
  },
};

// クレジットカード入力エレメント
const CardField = ({ onChange }: { onChange: any }) => (
  <div className='FormRow'>
    <CardElement options={CARD_OPTIONS} onChange={onChange} />
  </div>
);

interface Props {
  valid: (value: boolean) => void;
}
export default function SetupPayment(props: Props) {
  log.putLog('info', 'SetupPayment started.');
  const elements = useElements();
  const stripe = useStripe();
  const dispatch = useDispatch();
  const [isValid, setIsValid] = useState(false);

  const [error, setError] = useState<
    { type: 'validation_error'; code: string; message: string } | undefined
  >();
  const [cardComplete, setCardComplete] = useState(false);

  // 登録ボタンが押された
  const handleUpdate = async (e: any) => {
    e.preventDefault();

    if (error) return;

    const cardElement = elements!.getElement(CardElement);

    // カード情報のチェック
    if (!cardComplete) {
      alert('カード情報が正しくありません。');
      cardElement!.focus();
      setIsValid(false);
      return;
    }

    if (cardElement) {
      // カードトークンの作成
      const result = await stripe?.createToken(cardElement);
      console.log('🐞 Card token got.');
      console.dir(result?.token);

      // ストアに格納
      dispatch(setStripeCardTokenId(result?.token?.id));
      setIsValid(true);
    }
  };

  useEffect(() => {
    props.valid(isValid);
  }, [props, isValid]);

  return (
    <Paper
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        height: 'auto',
      }}
    >
      <Typography variant='h6' gutterBottom component='div' color={'gray'}>
        クレジットカード番号を入力してください。カード番号をクリックすると入力ができます。
        入力が完了したら、カード情報を登録ボタンを押してください。
      </Typography>
      <Container component='main' maxWidth='xs' sx={{ mt: 5 }}>
        <Stack spacing={2}>
          <CardField
            onChange={(e: StripeCardElementChangeEvent) => {
              setError(e.error);
              setCardComplete(e.complete);
            }}
          />
          <Button
            variant='outlined'
            color='primary'
            size='medium'
            onClick={handleUpdate}
            disabled={isValid}
          >
            カード情報を登録
          </Button>
          {isValid ? (
            <Typography color={'red'}>次へボタンを押してください。</Typography>
          ) : (
            ''
          )}
        </Stack>
      </Container>
    </Paper>
  );
}
